export default __webpack_public_path__ + "static/media/step4.d47bc678.png";